import { useEffect, useState } from "react"

const checkedValues = (inputName: string): string[] =>
  Array.from(document.querySelectorAll<HTMLInputElement>(`input[name="${inputName}"]:checked`)).map(
    (input) => input.value
  )

// The grid's select-all checkbox ticks rows without a change event of their own,
// so any change on the page re-reads the ticked rows.
const useSelectedTourIds = (inputName: string): string[] => {
  const [ids, setIds] = useState(() => checkedValues(inputName))

  useEffect(() => {
    const reread = () => setIds(checkedValues(inputName))

    document.addEventListener("change", reread)

    return () => document.removeEventListener("change", reread)
  }, [inputName])

  return ids
}

export default useSelectedTourIds
